import { useEffect, useRef, EffectCallback, DependencyList } from 'react'

/**
 * Like `useEffect`, but skips the run on mount - `effect` fires only when `dependencies` change afterwards.
 * Strict-Mode safe: the simulated unmount/remount resets the flag, so the remount is not mistaken for an update.
 */
const useUpdateEffect = (effect: EffectCallback, dependencies: DependencyList) => {
    const isMounted = useRef(false)

    useEffect(() => () => {
        isMounted.current = false
    }, [])

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true
            return
        }

        return effect()
    }, dependencies)
}

export default useUpdateEffect
